import { Injectable } from '@angular/core';
import * as lscache from 'lscache';
import { Observable, of } from 'rxjs';
import { Cacheable } from './cacheable.model';

@Injectable({
  providedIn: 'root'
})
export class CacheFactoryService {
  readonly CACHE_BUCKET = 'aiops_cache_bucket';
  readonly DEFAULT_CACHE_TTL = 60; // default to 60mins

  constructor() {
    lscache.setBucket(this.CACHE_BUCKET);
   }

  setCacheable(cache:Cacheable){
    const cachettl = (cache.ttl && cache.ttl !==0) ? cache.ttl : this.DEFAULT_CACHE_TTL;
    lscache.set(cache.key,cache.toCache,cachettl);
  }

  getCache(key: string): Observable<object>{
    return of(lscache.get(key));
  }

  isCacheAvailable(key: string): boolean{
    return (lscache.get(key) !== null);
  }

  removeCache(key: string): boolean {
    try {
      lscache.remove(key);
      return true;
    } catch (e) {
      return false;
    }
  }

  flushAllCache() {
    lscache.flush();
  }
}
